/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
import { Model as BaseModel } from 'vue-api-query';

export default class Model extends BaseModel {
    findResource(path) {
        return super.find(path.substr(this.resource().length + 2));
    }

    // define a base url for a REST API
    // noinspection JSMethodCanBeStatic
    baseURL() {
        return process.env.VUE_APP_API;
    }

    // implement a default request method
    request(config) {
        if (config.data) {
            config.body = config.data;
            delete config.data;
        }

        return this.$http(config);
    }

    get resourceId() {
        return `/${this.resource()}/${this.getPrimaryKey()}`;
    }
}
